import ReactDOM from 'react-dom'
import { ToastContainer, Zoom } from 'react-toastify';

const Toast = ({...rest}) => {
    return ReactDOM.createPortal(
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar
            transition={Zoom}
            newestOnTop={false}
            theme="colored"
            closeOnClick
            rtl={false}
            closeButton={false}
            pauseOnFocusLoss
            {...rest}
          />,
          document.getElementById("off-canvas")
        )
}

export default Toast;